import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { shipmentsListingApi } from '@apis/seller-center/shipments.js';
import { Toast } from '@common-web';
import { getErrorString } from '@utils/utils';

const initialState = {
  consignments: [],
  pagination: null,
  statuses: [],
  success: false,
  loading: false,
  aggregations: null,
};

export const fetchShipmentListing = createAsyncThunk('shipments/listing', async (params = '') => {
  try {
    const shipments = await shipmentsListingApi(params);
    return shipments;
  } catch (err) {
    Toast.error(getErrorString(err));
    return [];
  }
});

const ShipmentsSlice = createSlice({
  name: 'shipments',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchShipmentListing.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchShipmentListing.fulfilled, (state, action) => {
        state.consignments = action?.payload?.consignments;
        state.statuses = action?.payload?.statuses_and_dispositions ?? [];
        state.pagination = action?.payload?.pagination;
        state.aggregations = action?.payload?.aggregations;
        state.loading = false;
      });
  },
});

export default ShipmentsSlice.reducer;
